module.exports = __webpack_public_path__ + "img/iconmonstr-arrow-25.89b04cb0.svg";